
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"c-adCorner\" style=\"background-image: url(")
    ; __append(escape(img))
    ; __append(")\">\n    <div class=\"c-adCorner__close\">广告</div>\n        <!-- <div class=\"img_ad\"></div> -->\n    <!-- </div> -->\n</div>")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/modules/f.component.ad.mobile/app/modules/AdCorner/main.ejs
// module id = 544
// module chunks = 0